export const nowMilisecondsTimestamp = () => {
  return Date.now()
}

export const daysToSeconds = (days: number) => {
  return days * 24 * 60 * 60
}

export const secondsToDays = (seconds: number) => {
  return Math.floor(seconds / 60 / 60 / 24)
}

export const yearToSeconds = () => {
  return daysToSeconds(365)
}

export const hoursToMinutes = (hours: number) => {
  return hours * 60
}

export const hoursToSeconds = (hours: number) => {
  return hours * 60 * 60
}

export const hoursToMiliseconds = (hours: number) => {
  return hours * 60 * 60 * 1000
}

export const minutesToSeconds = (minutes: number) => {
  return minutes * 60
}

export const secondsToHours = (seconds: number) => {
  return seconds / 60 / 60
}

export const secondsToMiliseconds = (seconds: number) => {
  return seconds * 1000
}

export const milisecondsToSeconds = (miliseconds: number) => {
  return miliseconds / 1000
}

export const minutesToMiliseconds = (minutes: number) => {
  return minutes * 60 * 1000
}

export const milisecondsToHours = (miliseconds: number) => {
  return miliseconds / 1000 / 60 / 60
}

export const moreThanNMinutesAgo = (tsInMiliseconds: number, minutes: number) => {
  return nowMilisecondsTimestamp() - tsInMiliseconds > minutesToMiliseconds(minutes)
}

/**
 * Helper: format durtion
 * @param duration duration in hours
 * @returns a neatly-formatted durtion string
 */
export const formatDuration = (duration: number | null | undefined) => {
  if (duration === null || duration === undefined) {
    return ''
  }

  const hours = duration
  const rhours = Math.floor(hours)
  const minutes = hoursToMinutes(hours - rhours)
  const rminutes = Math.round(minutes)
  if (rhours) {
    return `${rhours}h ${rminutes}min`
  } else {
    return `${rminutes}min`
  }
}
